function LocalSeoSection() {
  return (
    <section className="section alt" id="local-seo">
      <div className="section-title">
        <p>Local Service Area</p>
        <h2>Best AC Service in Masrakh, Saran</h2>
      </div>
      <article className="card seo-card">
        <p>
          GURU KRIPA (Amar AC Service) provides AC service in Masrakh, AC service
          near me support, AC installation, AC gas filling, and washing machine
          repair near Station Road, Masrakh, Saran, Bihar.
        </p>
        <p>
          If users search for <strong>ac service in masrakh</strong>,{" "}
          <strong>ac service near me</strong>, <strong>washing machine repair</strong>,{" "}
          <strong>ac installation</strong>, or <strong>best ac service in masrakh</strong>,
          this website is optimized to match those local intents.
        </p>
        <h3>Frequently Asked Questions</h3>
        <p>
          <strong>Q:</strong> Do you provide same-day AC service in Masrakh?
        </p>
        <p>
          <strong>A:</strong> Yes, same-day visit is available in most cases based on
          slot availability.
        </p>
        <p>
          <strong>Q:</strong> Can I book AC installation and gas filling together?
        </p>
        <p>
          <strong>A:</strong> Yes, our team can inspect and complete installation and
          gas-related service in a planned visit.
        </p>
      </article>
    </section>
  );
}

export default LocalSeoSection;
